import { Home, LogOut, Menu, Table, User, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import api from "../api/axios";

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const links = [
    // { to: "/messages", label: "الرسائل", icon: MessageCircle },
    { to: "/appointments", label: "المواعيد", icon: Home },
    { to: "/profile", label: "الملف الشخصي", icon: User },
    { to: "/tablework", label: "لوحة العمل", icon: Table },
  ];

  // إغلاق الـ Sidebar عند تغيير المسار
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // إغلاق الـ Sidebar عند الضغط على ESC
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  const handleLogout = async () => {
    try {
      setLoading(true);
      await api.post("/logout");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      navigate("/login");
    } catch (error) {
      alert("فشل تسجيل الخروج");
    } finally {
      setLoading(false);
      setShowConfirm(false);
      setIsOpen(false);
    }
  };

  return (
    <>
      {/* زر القائمة للموبايل */}
      <button
        className="mobile-menu-btn"
        onClick={() => setIsOpen(true)}
        aria-label="فتح القائمة"
      >
        <Menu size={24} />
      </button>

      {/* Overlay */}
      {isOpen && (
        <div
          className="overlay"
          onClick={() => setIsOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar */}
      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
        <div className="sidebar-content">
          <div className="sidebar-header">
            <h2 className="sidebar-title">لوحة التحكم</h2>
            <button
              className="close-btn"
              onClick={() => setIsOpen(false)}
              aria-label="إغلاق القائمة"
            >
              <X size={24} />
            </button>
          </div>

          <nav className="nav">
            {links.map(({ to, label, icon: Icon }) => {
              const isActive = location.pathname === to;
              return (
                <Link
                  key={to}
                  to={to}
                  className={`nav-item ${isActive ? "active" : ""}`}
                  onClick={() => setIsOpen(false)}
                >
                  <Icon size={20} />
                  <span>{label}</span>
                </Link>
              );
            })}
          </nav>
        </div>

        <button onClick={() => setShowConfirm(true)} className="logout-btn">
          <LogOut size={20} />
          <span>تسجيل الخروج</span>
        </button>
      </aside>

      {/* Modal التأكيد */}
      {showConfirm && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>هل تريد تسجيل الخروج؟</h3>
            <div className="modal-actions">
              <button
                className="btn-confirm"
                onClick={handleLogout}
                disabled={loading}
              >
                {loading ? "جاري..." : "نعم"}
              </button>
              <button
                className="btn-cancel"
                onClick={() => setShowConfirm(false)}
                disabled={loading}
              >
                لا
              </button>
            </div>
          </div>
        </div>
      )}

      {/* CSS */}
      <style>{`
        * {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* زر القائمة */
.mobile-menu-btn {
  display: none;
  position: fixed;
  top: 15px;
  right: 15px; /* بدل left */
  z-index: 1100;
  background: #10b981;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,.15);
  transition: .3s;
}

.mobile-menu-btn:hover {
  background: #059669;
  transform: scale(1.05);
}

.mobile-menu-btn:active {
  transform: scale(.95);
}

/* Sidebar */

/* =======================
   Sidebar
======================= */

.sidebar{
  position: fixed;
  top: 16px;
  right: 16px;
  bottom: 16px;

  width: 270px;

  display:flex;
  flex-direction:column;
  justify-content:space-between;

  padding:22px;

  border-radius:24px;

  background:
    linear-gradient(
      180deg,
      rgba(16,185,129,.95),
      rgba(6,95,70,.95)
    );

  backdrop-filter: blur(20px);

  box-shadow:
      0 20px 60px rgba(0,0,0,.25),
      inset 0 1px rgba(255,255,255,.15);

  color:#fff;

  overflow:hidden;

  z-index:1000;
}

/* خلفية زخرفية */

.sidebar::before{
  content:"";

  position:absolute;

  top:-120px;
  left:-100px;

  width:250px;
  height:250px;

  border-radius:50%;

  background:rgba(255,255,255,.08);

  filter:blur(20px);
}

.sidebar::after{
  content:"";

  position:absolute;

  bottom:-80px;
  right:-70px;

  width:180px;
  height:180px;

  border-radius:50%;

  background:rgba(255,255,255,.05);
}
.sidebar-content{
  flex:1;
  overflow-y:auto;
}

.sidebar-header{
    position:relative;
    z-index:2;

    display:flex;
    flex-direction:column;
    align-items:center;

    margin-bottom:35px;
}

.sidebar-title{
    font-size:28px;
    font-weight:700;
    color:white;
    margin-top:12px;
}

.logo-circle{
    width:70px;
    height:70px;

    border-radius:50%;

    display:flex;
    justify-content:center;
    align-items:center;

    background:rgba(255,255,255,.15);

    border:1px solid rgba(255,255,255,.2);

    backdrop-filter:blur(10px);

    font-size:30px;
}

.sidebar-title{
  flex:1;
  color:#d1fae5;
  font-size:24px;
  font-weight:bold;
  text-align:center;
}

.close-btn{
  display:none;
  background:none;
  border:none;
  color:#d1fae5;
  cursor:pointer;
  padding:5px;
  border-radius:6px;
}

.close-btn:hover{
  background:rgba(255,255,255,.1);
}

/* Navigation */

.nav{
  display:flex;
  flex-direction:column;
  gap:10px;
}

.nav-item{
  display:flex;
  flex-direction:row-reverse; /* الأيقونة يمين */
  justify-content:flex-end;
  align-items:center;
  gap:12px;

  padding:14px 16px;

  text-decoration:none;

  color:#d1fae5;

  border-radius:10px;

  transition:.3s;
}

.nav-item:hover{
  background:rgba(255,255,255,.15);
  color:#fff;

  transform:translateX(-5px);
}

.nav-item.active{
  background:#34d399;
  color:#065f46;
  font-weight:bold;
}

/* Logout */

.logout-btn{
  display:flex;
  flex-direction:row-reverse;
  justify-content:center;
  align-items:center;
  gap:10px;

  background:#10b981;
  color:#065f46;

  border:none;
  border-radius:12px;

  padding:14px;

  font-size:16px;
  font-weight:600;

  cursor:pointer;

  transition:.3s;
}

.logout-btn:hover{
  background:#34d399;
}

/* Modal */

.modal-overlay{
  position:fixed;
  inset:0;
  background:rgba(0,0,0,.6);
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:2000;
}

.modal{
  background:#fff;
  padding:30px;
  border-radius:16px;
  min-width:300px;
  text-align:center;
}

.modal h3{
  color:#065f46;
  margin-bottom:25px;
}

.modal-actions{
  display:flex;
  justify-content:center;
  gap:15px;
}

.modal-actions button{
  padding:12px 30px;
  border:none;
  border-radius:8px;
  cursor:pointer;
}

.btn-confirm{
  background:#10b981;
  color:white;
}

.btn-cancel{
  background:#e5e7eb;
}

/* Overlay */

.overlay{
  display:none;
}

/* Mobile */

@media (max-width:768px){

.mobile-menu-btn{
display:flex;
align-items:center;
justify-content:center;
}

.sidebar{

right:-100%;      /* بدل left */

width:280px;

transition:right .3s ease;
}

.sidebar.open{

right:0;          /* بدل left */

}

.overlay{
display:block;
position:fixed;
inset:0;
background:rgba(0,0,0,.5);
z-index:1100;
}

.close-btn{
display:flex;
}

.sidebar-title{
font-size:20px;
}

}

/* ==========================
   Tablet
========================== */

@media (max-width:992px){

.sidebar{
    width:250px;
}

}

/* ==========================
   Mobile
========================== */

@media (max-width:768px){

.mobile-menu-btn{
    display:flex;
    align-items:center;
    justify-content:center;
}

.sidebar{

    top:0;
    right:-100%;
    bottom:0;

    width:280px;
    max-width:85%;
    height:100vh;

    border-radius:0;
    padding:20px;

    transition:right .3s ease;
}

.sidebar.open{
    right:0;
}

.overlay{
    display:block;
    position:fixed;
    inset:0;
    background:rgba(0,0,0,.45);
    z-index:999;
}

.close-btn{
    display:flex;
    position:absolute;
    left:15px;
    top:15px;
}

.sidebar-title{
    font-size:22px;
    margin-top:0;
}

.nav{
    margin-top:25px;
}

.nav-item{
    padding:15px;
    font-size:16px;
}

.logout-btn{
    margin-top:20px;
    padding:14px;
}

}

/* ==========================
   Small Phones
========================== */

@media (max-width:480px){

.mobile-menu-btn{
    top:10px;
    right:10px;
}

.sidebar{
    width:85%;
    max-width:300px;
    padding:18px;
}

.sidebar-title{
    font-size:20px;
}

.nav-item{
    font-size:15px;
    padding:13px;
}

.logout-btn{
    font-size:15px;
    padding:12px;
}

.modal{
    width:90%;
    min-width:auto;
    padding:20px;
}

.modal-actions{
    flex-direction:column;
}

.modal-actions button{
    width:100%;
}

}
      `}</style>
    </>
  );
}
